<script>
  import Icon from "@/core/components/Icon"
  import Loader from "@/core/components/loaders/BallClipRotate"

  export default {
    components: {
      Icon,
      Loader,
    },
    props: {
      code: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        status: "pending",
        error:
          "Houve um erro ao confirmar o cadastro, tente novamente ou mais tarde!",
      }
    },
    mounted() {
      this.confirm()
    },
    methods: {
      async confirm() {
        try {
          await this.$axios.get("/api/registry/user/confirm/" + this.code)
          this.status = "finished"
        } catch (e) {
          this.status = "rejected"
          this.error = e.response.data.error
            ? e.response.data.error
            : this.error
        }
      },
    },
  }
</script>

<template>
  <div
    class="flex flex-col justify-center h-auto min-h-screen px-1 bg-green-background"
  >
    <div class="p-12 mx-auto my-4 bg-white rounded shadow font-display">
      <div v-if="status === 'pending'" class="flex items-center justify-center">
        <loader wrapperClass="text-green-base" loaderClass="w-60 h-60"/>
      </div>
      <div
        v-else-if="status === 'finished'"
        class="flex flex-col items-center justify-center space-y-6 text-sm"
      >
        <icon
          icon="checkedCircle"
          class="fill-current h-28 text-green-base"
          aria-hidden="true"
        />
        <h3>Cadastro confirmado com successo!</h3>
        <router-link
          :to="{ name: 'login', params: {} }"
          class="w-full py-2 bg-green-base text-white hover:bg-green-dark"
        >
          Entrar
        </router-link>
      </div>
      <div
        v-else
        class="flex flex-col items-center justify-center space-y-6 text-sm"
      >
        <icon
          icon="close"
          class="fill-current h-28 text-red-base"
          aria-hidden="true"
        />
        <h3>{{ error }}</h3>
      </div>
    </div>
  </div>
</template>
